import Tabs from "components/BaseWidgets/tab";
import "./style.scss";
import SubscriptionCard from "components/Cards/subscriptionCard";
import { whyChooseSubscription } from "components/Plans/helper";
import PersonalizedTab from "../PersonalizedTab";
import SummaryModal from "../SummaryModal";
import SuccessModal from "../SuccessModal";
import { useEffect, useState } from "react";
import SubscriptionsTab from "../SubscriptionsTab";
import { storeToken } from "utils/storage";
import {
  useCreatePlan,
  usePaymentCallback,
  usePaymentStatus,
} from "hooks/api/usePlans";
import FailureModal from "../FailureModal";
import { useSearchParams } from "react-router-dom";
import AlertNotification from "components/CustomWidgets/alertNotification";
import BankDetailsCard from "../BankDetailsCard";

function PlansList() {
  const [searchParams] = useSearchParams();
  const [isSummaryModal, setSummaryModal] = useState(false);
  const [isSuccessModal, setSuccessModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [isFailed, setFailed] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState("");
  const txnid = searchParams.get("txnid");
  const coupon_id = searchParams.get("coupon_id");
  const { isLoading: loading } = usePaymentCallback(
    txnid,
    coupon_id ? coupon_id : null,
    {
      enabled: Boolean(txnid),
    },
  );

  const { mutate: fetchPaymentStatus } = usePaymentStatus({
    onSuccess: (data) => {
      const transactionData = data?.transaction_details[txnid];

      if (transactionData?.status === "success") {
        setSuccessModal(true);
      } else if (transactionData?.status === "failed") {
        setFailed(true);
        AlertNotification("error", transactionData?.error_Message);
      } else {
        AlertNotification("error", transactionData?.error_Message);
      }
    },
  });

  useEffect(() => {
    if (txnid) {
      fetchPaymentStatus({ txnid });
    }
  }, [txnid, fetchPaymentStatus]);

  const { mutate: createPayment, isLoading } = useCreatePlan({
    onSuccess: (data) => {
      setPaymentDetails(data?.payment_data);
      setSummaryModal(true);
    },
  });

  const handlePlanClick = (plan) => {
    setSelectedPlan(plan);
    createPayment({
      plan_id: plan?.plan_id,
    });
    storeToken("selectedPlan", JSON.stringify(plan));
  };

  const tabItems = [
    {
      key: "1",
      label: "Subscription plan",
      children: (
        <SubscriptionsTab onOk={handlePlanClick} isPending={isLoading} />
      ),
    },
    {
      key: "2",
      label: "Personalized assist ",
      children: (
        <PersonalizedTab onOk={handlePlanClick} isPending={isLoading} />
      ),
    },
  ];

  return (
    <>
      <div className="plan-container container plans-list-container">
        <Tabs
          isCentered
          items={tabItems}
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={(e) => setActiveTab(e)}
        />
        <BankDetailsCard />
        <SubscriptionCard
          title="Why choose a subscription?"
          data={
            activeTab === "1"
              ? whyChooseSubscription[1]
              : whyChooseSubscription[0]
          }
        />
      </div>
      <SummaryModal
        open={isSummaryModal}
        setOpen={setSummaryModal}
        plan={selectedPlan}
        paymentDetails={paymentDetails}
        createPayment={createPayment}
      />
      <SuccessModal open={isSuccessModal} setOpen={setSuccessModal} />
      <FailureModal open={isFailed} setOpen={setFailed} />
    </>
  );
}

export default PlansList;
